import Messenger from 'components/stream-messaging/messenger'

export default Messenger
